export const SaveChangesContract = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $id: 'http://example.com/product.schema.json',
    $title: 'Save changes modal',
    $description: 'JSON Schema Contract for Save Changes Modal',
    $type: 'object',
    properties: {
    }
};
